<template>
  <div class="popup-select">
    <div @click="open_select">
      <slot></slot>
    </div>
    <van-popup v-model="showPicker" position="bottom" round v-if="type !== 3">
      <van-picker
        v-if="type !== 3"
        :title="title"
        show-toolbar
        :value-key="type == 1 ? 'orgName' : 'projectName'"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showAdviser" position="bottom" round v-else>
      <van-picker
        class="advister"
        show-toolbar
        title="选择置业顾问"
        @confirm="selectAdviser(selectObj)"
        @cancel="showAdviser = false"
      >
        <template #columns-top>
          <ul class="define" @click="changeAdviser">
            <li
              v-for="(item, index) in columns"
              :key="item.id"
              :index="index"
              :style="{
                background: index === selectIndex ? '#0D9869' : '#F3F3F3',
                color: index === selectIndex ? '#fff' : '#333',
              }"
            >
              {{ item.managerName }}
            </li>
          </ul>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Picker, Toast } from 'vant';
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: 1,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    adviserDisabled: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    columns: function() {
      this.selectIndex = null;
    },
  },
  components: {
    'van-popup': Popup,
    'van-picker': Picker,
  },
  data() {
    return {
      showAdviser: false,
      showPicker: false,
      selectIndex: null,
      selectObj: {}, // 选择的置业顾问
    };
  },
  methods: {
    onConfirm(value, index) {
      this.showPicker = false;
      this.$emit('onSelect', { value, index });
    },
    changeAdviser(e) {
      let index = e.target.getAttribute('index');
      if (index) {
        this.selectIndex = Number(index);
        this.selectObj = this.columns[index];
      }
    },
    selectAdviser(value) {
      this.showAdviser = false;
      this.$emit('onSelect', { value });
    },
    open_select() {
      if (this.disabled) {
        this.showPicker = true;
        // Toast('请先选择公司');
      } else {
        this.showPicker = true;
        if (this.adviserDisabled && this.type === 3) {
          this.showAdviser = true;
          // Toast('请先选择项目');
        } else {
          this.showAdviser = true;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.advister {
  .define {
    width: 100%;
    height: 440px;
    padding: 10px;
    overflow: hidden;
    box-sizing: border-box;
    overflow: scroll;
    display: flex;
    flex-wrap: wrap;
    li {
      list-style: none;
      display: flex;
      margin-left: 20px;
      margin-top: 24px;
      align-items: center;
      justify-content: center;
      width: 216px;
      height: 88px;
      background: rgba(243, 243, 243, 1);
      border-radius: 12px;
    }
  }
  .van-picker__columns {
    display: none;
  }
}
</style>
<style lang="scss">
.popup-select {
  .van-picker__confirm {
    color: #0d9869;
    font-size: 32px;
  }
  .van-picker__cancel {
    color: #999999;
    font-size: 32px;
  }
}
</style>
